(function () {
    'use strict';

    angular
        .module('emails')
        .config(EmailsRoute);

    EmailsRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function EmailsRoute ($stateProvider) {
        $stateProvider
            .state('root.emails', {
                abstract: true,
                url: '/emails',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state('root.emails.audiences', {
                url: '/audiences',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/audience/list.html',
                        controller: 'AudienceController',
                        controllerAs: 'audienceController'
                    }
                }
            })
            .state('root.emails.audiences.create', {
                url: '/create',
                resolve: {
                    embed: function () {
                        return false;
                    },
                    edit: function () {
                        return false;
                    },
                    mode: function(){
                        return 'create';
                    }
                },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/audience/form/form.html',
                        controller: 'SendToUserController',
                        controllerAs: 'SendToUser'
                    }
                }
            })
            .state('root.emails.audiences.replicate', {
                url: '/{audienceId}/replicate',
                resolve: {
                    embed: function () {
                        return false;
                    },
                    edit: function () {
                        return false;
                    },
                    mode: function(){
                        return 'replicate';
                    }
                },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/audience/form/form.html',
                        controller: 'SendToUserController',
                        controllerAs: 'SendToUser'
                    }
                }
            })
            .state('root.emails.audiences.edit', {
                url: '/{audienceId}/edit',
                resolve: {
                    embed: function () {
                        return false;
                    },
                    edit: function () {
                        return true;
                    },
                    mode: function(){
                        return 'edit';
                    }
                },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/audience/form/form.html',
                        controller: 'SendToUserController',
                        controllerAs: 'SendToUser'
                    }
                }
            })
            .state('root.emails.campaignList', {
                url: '/campaign/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/campaign/list/list.html',
                        controller: 'ManagerController',
                        controllerAs: 'managerController'
                    }
                }
            })
            // .state('root.emails.campaign', {
            //     url: '/campaign',
            //     views: {
            //         'inner-view@root': {
            //             templateUrl: 'templates/emails/campaign/form/form.html',
            //             controller: 'CampaignController',
            //             controllerAs: 'Campaign'
            //         }
            //     },
            //     resolve: {
            //         mode: function(){
            //             return 'create';
            //         }
            //     }
            // })
            .state('root.emails.campaignEmail', {
                url: '/campaign/email',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/campaign/form/form.html',
                        controller: 'CampaignController',
                        controllerAs: 'Campaign'
                    }
                },
                resolve: {
                    mode: function(){
                        return 'create';
                    },
                    chooseType: function(){
                        return 'email';
                    }
                }
            })
            .state('root.emails.campaignSms', {
                url: '/campaign/sms',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/campaign/form/form.html',
                        controller: 'CampaignController',
                        controllerAs: 'Campaign'
                    }
                },
                resolve: {
                    mode: function(){
                        return 'create';
                    },
                    chooseType: function(){
                        return 'sms';
                    }
                }
            })
            .state('root.emails.campaignChooseType', {
                url: '/campaign/chooseType',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/campaign/ChooseType/index.html',
                        controller: 'CampaignChooseTypeController',
                        controllerAs: 'CampaignChooseType'
                    }
                }
            })
            .state('root.emails.campaignEmail.edit', {
                url: '/{CampaignId}/edit',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/campaign/form/form.html',
                        controller: 'CampaignController',
                        controllerAs: 'Campaign'
                    }
                },
                resolve: {
                    mode: function(){
                        return 'edit';
                    }
                },
                chooseType: function(){
                    return 'email';
                }
            })
            .state('root.emails.campaignSms.edit', {
                url: '/{CampaignId}/edit',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/campaign/form/form.html',
                        controller: 'CampaignController',
                        controllerAs: 'Campaign'
                    }
                },
                resolve: {
                    mode: function(){
                        return 'edit';
                    }
                },
                chooseType: function(){
                    return 'sms';
                }
            })
            .state('root.emails.campaignEmail.replicate', {
                url: '/{CampaignId}/replicate',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/campaign/form/form.html',
                        controller: 'CampaignController',
                        controllerAs: 'Campaign'
                    }
                },
                resolve: {
                    mode: function(){
                        return 'replicate';
                    },
                    chooseType: function(){
                        return 'email';
                    }
                }
            })
            .state('root.emails.campaignSms.replicate', {
                url: '/{CampaignId}/replicate',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/campaign/form/form.html',
                        controller: 'CampaignController',
                        controllerAs: 'Campaign'
                    }
                },
                resolve: {
                    mode: function(){
                        return 'replicate';
                    },
                    chooseType: function(){
                        return 'sms';
                    }
                }
            })
            .state('root.emails.campaign.create', {
                url: '/campaign/create_campaing',
                resolve: {
                    embed: function () {
                        return true;
                    },
                    edit: function () {
                        return false;
                    }
                },
                views: {
                    create_audience: {
                        templateUrl: 'templates/emails/audience/form/form.html',
                        controller: 'SendToUserController',
                        controllerAs: 'SendToUser'
                    }
                }
            })
            .state('root.emails.campaignSms.create', {
                url: '/create_campaing',
                resolve: {
                    embed: function () {
                        return true;
                    },
                    edit: function () {
                        return false;
                    }
                },
                views: {
                    create_audience: {
                        templateUrl: 'templates/emails/audience/form/form.html',
                        controller: 'SendToUserController',
                        controllerAs: 'SendToUser'
                    }
                }

            })
            .state('root.emails.campaignEmail.create', {
                url: '/create_campaing',
                resolve: {
                    embed: function () {
                        return true;
                    },
                    edit: function () {
                        return false;
                    }
                },
                views: {
                    create_audience: {
                        templateUrl: 'templates/emails/audience/form/form.html',
                        controller: 'SendToUserController',
                        controllerAs: 'SendToUser'
                    }
                }
            })
            .state('root.emails.overview', {
                url: '/overview',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/overview/list.html',
                        controller: 'OverviewController',
                        controllerAs: 'overview'
                    }
                }
            })
            .state('root.emails.sendSurvey', {
                url: '/survey',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/sendSurvey/list.html',
                        controller: 'SendSurveyController',
                        controllerAs: 'sendSurveyController'
                    }
                }
            })
            .state('root.emails.sendSurveyPhysicalFair', {
                url: '/survey/expo/physical',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/SendSurveyPhysicalFair/list.html',
                        controller: 'SendSurveyPhysicalFairController',
                        controllerAs: 'SendSurveyPhysicalFairController'
                    }
                }
            })
            .state('root.emails.tokenLetter', {
                url: '/token-letter',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/emails/token_letter/list.html',
                        controller: 'TokenLetterController',
                        controllerAs: 'tokenLetterController'
                    }
                }
            })
    }
})();